module.exports = __webpack_public_path__ + "static/img/company_pageTop_desktop.607b1e14.jpg";